import { useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useRedirecionamentoAoLogin = (rotasPublicas = ['/login', '/error']) => {
  const navegar = useNavigate();
  const localizacao = useLocation();

  // Função para verificar a autenticação do usuário
  const verificarAutenticacao = useCallback(() => {
    const token = localStorage.getItem('token');
    const ehRotaPublica = rotasPublicas.includes(localizacao.pathname);
    const is_primeiro_login = JSON.parse(localStorage.getItem('is_primeiro_login') || 'false');

    console.log('Verificando autenticação...');
    console.log('Token:', token);
    console.log('É rota pública?', ehRotaPublica);

    if (!token && !ehRotaPublica) {
      console.log('Usuário não autenticado, redirecionando para /login');
      navegar('/login', { replace: true });
    } else if (token && ehRotaPublica) {
      const destino = is_primeiro_login ? '/inicio' : '/inicio';
      console.log('Usuário autenticado, redirecionando para:', destino);
      navegar(destino, { replace: true });
    }
  }, [navegar, localizacao, rotasPublicas]);

  // Captura e salva a URL anterior
  useEffect(() => {
    const urlAtual = localizacao.pathname + localizacao.search;
    const ehRotaPublica = rotasPublicas.includes(localizacao.pathname);

    console.log('Capturando URL atual:', urlAtual);

    if (!ehRotaPublica && urlAtual !== '/login') {
      console.log('Salvando URL anterior no sessionStorage:', urlAtual);
      sessionStorage.setItem('urlAnterior', urlAtual);
    }
  }, [localizacao.pathname, localizacao.search, rotasPublicas]);

  // Redireciona o usuário após o login
  const redirecionarAposLogin = useCallback(() => {
    const urlAnterior = sessionStorage.getItem('urlAnterior');
    const is_primeiro_login = JSON.parse(localStorage.getItem('is_primeiro_login') || 'false');

    console.log('URL anterior:', urlAnterior);
    console.log('É primeiro login?', is_primeiro_login);

    if (!urlAnterior || urlAnterior === '/' || rotasPublicas.includes(urlAnterior.split('?')[0])) {
      const destino = is_primeiro_login ? '/inicio' : '/inicio';
      console.log('Redirecionando para:', destino);
      navegar(destino, { replace: true });
    } else {
      console.log('Redirecionando para URL anterior:', urlAnterior);
      navegar(urlAnterior, { replace: true });
      sessionStorage.removeItem('urlAnterior');
    }
  }, [navegar, rotasPublicas]);

  // Verifica autenticação sempre que a rota mudar
  useEffect(() => {
    verificarAutenticacao();
  }, [verificarAutenticacao]);

  return { redirecionarAposLogin, verificarAutenticacao };
};

export default useRedirecionamentoAoLogin;
